import { render } from "./HRProfessionalProgramEng.vue?vue&type=template&id=7397efe8&scoped=true&lang=html"
import script from "./HRProfessionalProgramEng.vue?vue&type=script&lang=js"
export * from "./HRProfessionalProgramEng.vue?vue&type=script&lang=js"

import "./HRProfessionalProgramEng.vue?vue&type=style&index=0&id=7397efe8&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-7397efe8"

export default script